module.exports = __webpack_public_path__ + "img/gateway-light-switch-sm.e4df59de.svg";